import { t } from '@lingui/macro';
import { Documents } from 'components/Documents/Documents';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';

export const DocumentsPage = () => {
  return (
    <BaseLayout
      pageTitle={t`Documents | Introducer Portal`}
      contentPadding={false}
    >
      <Documents />
    </BaseLayout>
  );
};
